const NotLicensePage = () => (
        <div>
          <img src="/images/photokey.jpeg"  alt="Empty Branch"
            style={{ width: '60%', height: '60%', borderRadius: '20px',alignItems: 'center',justifyContent: 'center',display: 'flex',margin: 'auto',marginTop: '50px'}}
          />
          <h6 style={{ fontSize:'35px', fontWeight:'bold', textAlign:'center'}} >Falta un paso más</h6>
          <h1 style={{ fontSize:'25px', textAlign:'center'}}>Contacta a tu administrador para que pueda ayudarte a activar tu licencia.</h1>
        </div>
      )

export default NotLicensePage;
